module.exports = __webpack_public_path__ + "static/media/dashboard-red.65ead846.svg";